import { useApiClient } from '../client.js'

export const PUT_EXTRA_DATA_TO_EXPERIMENT_WITH_RELATION_ID_ENDPOINT = '/core/v2/experiment/{experimentName}/experiment_variant/{relationId}'

export function putExtraDataToExperimentWithRelationId (relationId, experimentName, extraData) {
  const apiClient = useApiClient()

  return apiClient.put({
    url: PUT_EXTRA_DATA_TO_EXPERIMENT_WITH_RELATION_ID_ENDPOINT,
    urlParams: {
      relationId,
      experimentName,
    },
    data: {
      extra_data: extraData,
    },
  })
}
